import styled, { css, keyframes } from 'styled-components';
import { Button } from '../Button/Button';
import { IStyledProps } from 'theme';

export const StyledStrategyExercisesButton = styled(Button)`
    & h6{
        font-family: Overpass;
        font-weight: 400;
        letter-spacing: 1.5px !important;
    }
`;
